// extracted by mini-css-extract-plugin
export var box = "_1c-2";
export var checkboxControl = "_1c-0";
export var checkboxRow = "_1c-a";
export var checked = "_1c-3";
export var descriptionSpacer = "_1c-c";
export var disabled = "_1c-4";
export var icon = "_1c-8";
export var input = "_1c-1";
export var labelSpacer = "_1c-b";
export var large = "_1c-7";
export var medium = "_1c-6";
export var small = "_1c-5";
export var text = "_1c-9";